<script setup lang="ts">
import { inject, onMounted, onUnmounted, computed } from 'vue'
import { Tabs } from '@ark-ui/vue'
import type { UiIconProps } from './UiIcon.vue'

export interface UiTabsLayoutItemProps {
  value: string
  label: string
  description?: string
  locked?: boolean
  disabled?: boolean
  hideDescriptionUnlessSelected?: boolean
  icon?: UiIconProps['name']
}

const props = withDefaults(defineProps<UiTabsLayoutItemProps>(), {
  value: '',
  label: '',
  locked: false,
  disabled: undefined,
})

const registerItem = inject<(item: any) => void>('UiTabsLayout:registerItem')
const unregisterItem = inject<(value: string) => void>('UiTabsLayout:unregisterItem')

onMounted(() => {
  registerItem?.({ value: props.value, label: props.label, description: props.description, locked: props.locked, disabled: props.disabled, icon: props.icon, hideDescriptionUnlessSelected: props.hideDescriptionUnlessSelected })
})

onUnmounted(() => {
  unregisterItem?.(props.value)
})

const isLocked = computed(() => Boolean(props.locked))
</script>

<template>
  <Tabs.Content :value="props.value" class="block">
    <slot :locked="isLocked" />
  </Tabs.Content>
</template>

